import React from 'react';
import { createRoot } from 'react-dom/client';
import NewLanding from './landing/NewLanding';

const container = document.getElementById('landingApp');
if (container) {
    const root = createRoot(container);
    root.render(<NewLanding />);
}

// Default export to fix Sentry warning
export default {};
